
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2E5939] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <div className="text-3xl font-bold text-white mb-4" style={{ fontFamily: '"Fredoka", sans-serif' }}>
                Creative Journeys Learning Center
              </div>
              <p 
                className="text-white/80 leading-relaxed max-w-md"
                style={{ fontFamily: '"Open Sans", sans-serif' }}
              >
                At Creative Journeys, we believe early education should feel like an extension of home — warm, safe, and filled with developmental learning experiencies. Our approach blends creativity, structure, and individualized care, which helps each child grow socially, emotionally, and academically.
              </p>
            </div>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-[#FFD84C] mr-3 text-lg"></i>
                <span style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  423 Edgewood Rd, Edgewood, MD 212040
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[#FFD84C] mr-3 text-lg"></i>
                <span style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  410-676-9002
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[#FFD84C] mr-3 text-lg"></i>
                <span style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  info@CreativeJourneysChildCare.com
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-[#FFD84C] mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/"
                  className="text-white/80 hover:text-[#FFD84C] transition-colors"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/about"
                  className="text-white/80 hover:text-[#FFD84C] transition-colors"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/programs"
                  className="text-white/80 hover:text-[#FFD84C] transition-colors"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link 
                  to="/admissions"
                  className="text-white/80 hover:text-[#FFD84C] transition-colors"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Admissions
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-white/80 hover:text-[#FFD84C] transition-colors"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Contact & Tours
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 
              className="text-lg font-semibold mb-6 text-[#FFD84C]"
              style={{ fontFamily: '"Poppins", sans-serif' }}
            >
              Our Programs
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'Infants (6w-12m)', path: '/programs' },
                { name: 'Toddlers (12m-2y)', path: '/programs' },
                { name: 'Preschool (3-4y)', path: '/programs' },
                { name: 'Pre-K (4-5y)', path: '/programs' },
                { name: 'Curriculum', path: '/programs/curriculum' }
              ].map((program) => (
                <li key={program.name}>
                  <Link 
                    to={program.path}
                    className="text-white/80 hover:text-[#FFD84C] transition-colors duration-200"
                    style={{ fontFamily: '"Open Sans", sans-serif' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {program.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Admissions */}
          <div>
            <h3 
              className="text-lg font-semibold mb-6 text-[#FFD84C]"
              style={{ fontFamily: '"Poppins", sans-serif' }}
            >
              Admissions
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'How to Enroll', path: '/admissions/enroll' },
                { name: 'Tuition & Fees', path: '/admissions/tuition' },
                { name: 'Forms & Downloads', path: '/admissions/forms' }
              ].map((admission) => (
                <li key={admission.name}>
                  <Link 
                    to={admission.path}
                    className="text-white/80 hover:text-[#FFD84C] transition-colors duration-200"
                    style={{ fontFamily: '"Open Sans", sans-serif' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {admission.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Media & Hours */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-6 md:mb-0">
              <h4 
                className="text-lg font-semibold mb-3 text-[#FFD84C]"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Hours of Operation
              </h4>
              <div 
                className="text-white/80 space-y-1"
                style={{ fontFamily: '"Open Sans", sans-serif' }}
              >
                <div>Monday - Friday: 6:30 AM - 5:00 PM</div>
                <div>Saturday: Closed</div>
                <div>Sunday: Closed</div>
              </div>
            </div>

            <div className="text-center">
              <h4 
                className="text-lg font-semibold mb-3 text-[#FFD84C]"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Follow Us
              </h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/CreativeJourneysChildCare/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#FFD84C] transition-colors duration-200">
                  <i className="ri-facebook-fill text-2xl"></i>
                </a>
                <a href="https://www.youtube.com/@creativejourneyschildcarel5091" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#FFD84C] transition-colors duration-200">
                  <i className="ri-youtube-line text-2xl"></i>
                </a>
                <a href="https://share.google/dDQoXhBBKZEDyPW7w" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#FFD84C] transition-colors duration-200">
                  <i className="ri-google-fill text-2xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p 
            className="text-white/60"
            style={{ fontFamily: '"Open Sans", sans-serif' }}
          >
            © 2024 Creative Journeys Learning Center. All rights reserved. | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#FFD84C] hover:text-white transition-colors duration-200 ml-1"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
